import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../../../context/AuthContext";
import axios from "axios";
import Swal from "sweetalert2";
import { API_BASE_URL } from "../../../../../Helpers/apiConfig";

export const AdminPackageEditCorporate = () => {
    const params = useParams();
    const { t } = useTranslation();
    const { user } = useAuth();

    const [msg, setMsg] = useState("");
    const [loading, setLoading] = useState(true);
    const [loadingSections, setLoadingSections] = useState(true);
    const [sections, setSections] = useState([]);
    const [form, setForm] = useState({
        id: "",
        packageName: "",
        packageDetail: "",
        packagePrice: "",
        studentLimit: "",
        howManyDays: "",
        sectionId: "",
        isActive: "true"
    });

    const headers = {
        accept: "*/*",
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": "false",
        Authorization: "Bearer " + user.token
    };

    useEffect(() => {
        const fetchAll = async () => {
            try {

                const packageUrl = API_BASE_URL + "/admin/Package/Get";
                const sectionUrl = API_BASE_URL + "/admin/SectionManager/GetList";
                const [packageRes, sectionRes] = await Promise.all([
                    axios({
                        method: "GET",
                        url: packageUrl,
                        params: { id: params.id },
                        headers
                    }),
                    axios({
                        method: "GET",
                        url: sectionUrl,
                        headers
                    })
                ]);

                if (packageRes.status === 200 && packageRes.data?.success) {
                    const item = packageRes.data.data;
                    setForm({
                        id: item.id,
                        packageName: item.packageName || "",
                        packageDetail: item.packageDetail || "",
                        packagePrice: item.packagePrice ?? "",
                        studentLimit: item.studentLimit ?? "",
                        howManyDays: item.howManyDays ?? "",
                        sectionId: item.sortNumber != null ? String(item.sortNumber) : "",
                        isActive: String(item.isActive)
                    });
                } else {
                    setMsg(packageRes.data?.message || "Paket bilgisi alınamadı.");
                }

                if (sectionRes.status === 200 && sectionRes.data?.success) {
                    const activeSections = (sectionRes.data.data || []).filter(
                        (section) => section.isDeleted === false && section.isActive === true
                    );
                    setSections(activeSections);
                } else {
                    setMsg((prev) => prev || sectionRes.data?.message || "Sectionlar alınamadı.");
                }
            } catch (err) {
                setMsg(err?.message || "Beklenmedik bir hata oluştu.");
            } finally {
                setLoading(false);
                setLoadingSections(false);
            }
        };

        fetchAll();
    }, [params.id, user.token]);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setForm((prev) => ({ ...prev, [id]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const url = API_BASE_URL + "/admin/Package/Update";

            const res = await axios({
                method: "PUT",
                url,
                data: {
                    id: form.id,
                    isDeleted: false,
                    packageName: form.packageName,
                    packageDetail: form.packageDetail,
                    packageFeaturedImage: null,
                    packagePrice: Number(form.packagePrice),
                    studentLimit: Number(form.studentLimit),
                    isActive: form.isActive === "true",
                    howManyDays: Number(form.howManyDays),
                    isInvidual: false,
                    isItPrivate: false,
                    sortNumber: Number(form.sectionId)
                },
                headers
            });

            if (res.status === 200 && res.data?.success) {
                await Swal.fire({
                    title: "Güncellendi!",
                    icon: "success",
                    confirmButtonText: "Tamam"
                });
                window.location.reload();
                return;
            }

            setMsg(res.data?.message || "Beklenmedik bir hata oluştu.");
        } catch (err) {
            setMsg(err?.message || "Beklenmedik bir hata oluştu.");
        }
    };

    return (
        <div className="container-fluid py-3 py-md-4">
            <div className="row justify-content-center">
                <div className="col-12 col-lg-9 col-xl-8">
                    <div className="card shadow-sm border-0">
                        <div className="card-body p-3 p-md-4">
                            <div className="text-center mb-4">
                                <h1 className="h3 mb-1">Kurumsal Paket Düzenle</h1>
                            </div>

                            {msg ? <div className="alert alert-danger">{msg}</div> : null}

                            {loading ? (
                                <div className="text-center">Yükleniyor...</div>
                            ) : (
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="packageName" className="form-label">
                                            {t("packageName")}
                                        </label>
                                        <textarea
                                            className="form-control"
                                            id="packageName"
                                            value={form.packageName}
                                            onChange={handleChange}
                                            rows={2}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="packageDetail" className="form-label">
                                            {t("packageDescription")}
                                        </label>
                                        <textarea
                                            className="form-control"
                                            id="packageDetail"
                                            value={form.packageDetail}
                                            onChange={handleChange}
                                            rows={3}
                                        />
                                    </div>

                                    <div className="row">
                                        <div className="col-12 col-md-6 mb-3">
                                            <label htmlFor="packagePrice" className="form-label">
                                                {t("packagePrice")}
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                id="packagePrice"
                                                value={form.packagePrice}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        <div className="col-12 col-md-6 mb-3">
                                            <label htmlFor="studentLimit" className="form-label">
                                                Toplam Öğrenci Sayısı
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                id="studentLimit"
                                                value={form.studentLimit}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12 col-md-6 mb-3">
                                            <label htmlFor="howManyDays" className="form-label">
                                                {t("validityDate")}
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                id="howManyDays"
                                                value={form.howManyDays}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        <div className="col-12 col-md-6 mb-3">
                                            <label htmlFor="sectionId" className="form-label">
                                                Section
                                            </label>
                                            <select
                                                id="sectionId"
                                                className="form-select"
                                                value={form.sectionId}
                                                onChange={handleChange}
                                                required
                                                disabled={loadingSections}
                                            >
                                                <option value="">
                                                    {loadingSections ? "Sectionlar yükleniyor..." : t("select")}
                                                </option>
                                                {sections.map((section) => (
                                                    <option key={section.id} value={section.id}>
                                                        {section.sectionName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12 col-md-6 mb-3">
                                            <label htmlFor="isActive" className="form-label">
                                                {t("isActive")}
                                            </label>
                                            <select
                                                id="isActive"
                                                className="form-select"
                                                value={form.isActive}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="true">{t("active")}</option>
                                                <option value="false">{t("passive")}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="d-grid d-md-flex justify-content-md-center mt-4">
                                        <button type="submit" className="btn btn-primary btn-lg px-4">
                                            {t("update")}
                                        </button>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminPackageEditCorporate;